import { createContext, type ReactNode, useContext } from "react";
import type { Socket } from "socket.io-client";

type ProviderProps = {
  socket?: Socket;
  children: ReactNode;
};

const context = createContext<Socket | undefined>(undefined);

export const useSocket = () => useContext(context);

export function SocketProvider({ socket, children }: ProviderProps) {
  return <context.Provider value={socket}>{children}</context.Provider>;
}
